import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
  type MutableRefObject,
} from "react";

const useIsomorphicLayoutEffect =
  typeof window !== "undefined" ? useLayoutEffect : useEffect;

type UseImageLoaded = {
  imgRef: MutableRefObject<HTMLImageElement | null>;
  loaded: boolean;
  onLoad: () => void;
  aspectRatio: number | null;
};

export function useImageLoaded(): UseImageLoaded {
  const [loaded, setLoaded] = useState(false);
  const [aspectRatio, setAspectRatio] = useState<number | null>(null);
  const imgRef = useRef<HTMLImageElement | null>(null);

  const capture = useCallback((img: HTMLImageElement) => {
    setLoaded(true);
    if (img.naturalWidth > 0 && img.naturalHeight > 0) {
      setAspectRatio(img.naturalWidth / img.naturalHeight);
    }
  }, []);

  useIsomorphicLayoutEffect(() => {
    if (imgRef.current?.complete && imgRef.current.naturalWidth > 0) {
      capture(imgRef.current);
    }
  }, [capture]);

  const onLoad = useCallback(() => {
    if (imgRef.current) capture(imgRef.current);
  }, [capture]);

  return { imgRef, loaded, onLoad, aspectRatio };
}
